import React, { useState, useRef } from 'react';
import { getImages } from '../const';
import { Formik, Form, Field } from 'formik';

const ServiceSpecials = () => {
    const [completeSpecialsData, setCompleteSpecialsData] = useState([]);
    const [specials, setSpecials] = useState([
        { id: 1, title: '', description: '', price: '', showPrice: false, image: null }
    ]);

    // Array of refs for file inputs
    const fileInputRefs = useRef({});

    const addNewSpecial = () => {
        setSpecials(prev => [
            ...prev,
            { id: Date.now(), title: '', description: '', price: '', showPrice: false, image: null }
        ]);
    };

    const handleSubmit = (values, index) => {
        console.log(`Form ${index + 1} submitted:`, values);
        // alert(`Form ${index + 1} saved successfully!`);
        setCompleteSpecialsData(prev => [...prev, values]);
    };

    const handleImageChange = (e, setFieldValue, specialId) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setFieldValue('image', reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    console.log('completeSpecialsData', completeSpecialsData);

    return (
        <section className='admin-common-wrap'>
            <div className='container mxw-1180'>
                <div className='admin-black-box'>
                    {/* Header */}
                    <div className='d-flex mss-heading-flex align-items-center justify-content-between'>
                        <div className='md-title font-1-8em text-uppercase fw-700'>
                            Manage Service Specials
                        </div>
                        <div className='d-flex align-items-center'>
                            <div>
                                <button
                                    type='button'
                                    onClick={addNewSpecial}
                                    className='orange-btn text-uppercase add-new-special-btn'
                                >
                                    <img src={getImages('white-plus-icon.svg')} alt='add' />
                                    <span className='fw-300'>Add New Special</span>
                                </button>
                            </div>
                            <div className='position-relative ss-search-block'>
                                <input
                                    type='text'
                                    className='form-control'
                                    placeholder='Search'
                                />
                            </div>
                        </div>
                    </div>

                    {/* Dynamic Form Boxes */}
                    <div className='row g-4'>
                        {specials.map((special, index) => (
                            <div className='col-md-6' key={special.id}>
                                <div className='mss-box custom-form mss-custom-form'>
                                    <Formik
                                        enableReinitialize
                                        initialValues={special}
                                        onSubmit={(values) => handleSubmit(values, index)}
                                    >
                                        {({ values, setFieldValue, form }) => (
                                            <Form>
                                                {/* Upload Section */}
                                                <div
                                                    className={`mss-box-upload ${values.image ? 'has-image' : ''}`}
                                                    onDragOver={(e) => e.preventDefault()}
                                                    onDragLeave={(e) => e.preventDefault()}
                                                    onDrop={(e) => {
                                                        e.preventDefault();
                                                        const file = e.dataTransfer.files[0];
                                                        if (file && file.type.startsWith('image/')) {
                                                            const reader = new FileReader();
                                                            reader.onloadend = () => {
                                                                setFieldValue('image', reader.result);
                                                            };
                                                            reader.readAsDataURL(file);
                                                        }
                                                    }}
                                                >
                                                    {values.image ? (
                                                        <img
                                                            src={values.image}
                                                            alt='preview'
                                                        />
                                                    ) : (
                                                        <img
                                                            src={getImages('upload-icon-box.webp')}
                                                            alt='upload placeholder'
                                                        />
                                                    )}
                                                </div>

                                                <div className='d-flex align-items-center justify-content-between mt-3 mb-4'>
                                                    <div>
                                                        <button
                                                            type='button'
                                                            className='upload-photo-btn'
                                                            onClick={() =>
                                                                fileInputRefs.current[special.id].click()
                                                            }
                                                        >
                                                            <img
                                                                src={getImages('photo-camera-material.png')}
                                                                alt='camera'
                                                            />{' '}
                                                            Upload Photo
                                                        </button>

                                                        {/* Hidden File Input */}
                                                        <input
                                                            type='file'
                                                            accept='image/*'
                                                            ref={(el) => (fileInputRefs.current[special.id] = el)}
                                                            onChange={(e) =>
                                                                handleImageChange(e, setFieldValue, special.id)
                                                            }
                                                            style={{ display: 'none' }}
                                                        />
                                                    </div>

                                                    {/* Dropdown */}
                                                    <div className='dropdown-center mss-dropdown'>
                                                        <button
                                                            className='btn btn-secondary dropdown-toggle'
                                                            type='button'
                                                            data-bs-toggle='dropdown'
                                                            aria-expanded='false'
                                                        >
                                                            <img
                                                                src={getImages('mm-dropdown-icon.svg')}
                                                                alt='menu'
                                                            />
                                                        </button>
                                                        <ul className='dropdown-menu'>
                                                            <li>
                                                                <button
                                                                    type='button'
                                                                    className='dropdown-item'
                                                                    onClick={() => alert('Published')}
                                                                >
                                                                    Publish
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button
                                                                    type='button'
                                                                    className='dropdown-item'
                                                                    onClick={() => alert('Edit')}
                                                                >
                                                                    Edit
                                                                </button>
                                                            </li>
                                                            <li>
                                                                <button
                                                                    type='button'
                                                                    className='dropdown-item di-red'
                                                                    onClick={() => {
                                                                        setSpecials(prev =>
                                                                            prev.filter(
                                                                                item => item.id !== special.id
                                                                            )
                                                                        );
                                                                        setCompleteSpecialsData(prev =>
                                                                            prev.filter(
                                                                                item => item.id !== special.id
                                                                            )
                                                                        );
                                                                    }}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                {/* Title */}
                                                <div className='form-group'>
                                                    <div className='cs-label'>Title</div>
                                                    <Field
                                                        name='title'
                                                        type='text'
                                                        className='form-control'
                                                    />
                                                </div>

                                                {/* Description */}
                                                <div className='form-group'>
                                                    <div className='cs-label'>Description</div>
                                                    <Field
                                                        as='textarea'
                                                        name='description'
                                                        className='form-control h-120'
                                                    />
                                                </div>

                                                {/* Price Section */}
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className={`cs-label ${!values.showPrice ? 'disabled' : ''}`}>
                                                            Price
                                                        </div>
                                                    </div>
                                                    <div className='col-6'>
                                                        <div className='form-group'>
                                                            <Field name='price'>
                                                                {({ field, form }) => (
                                                                    <input
                                                                        {...field}
                                                                        type='text'
                                                                        className='form-control'
                                                                        disabled={!form.values.showPrice}
                                                                        placeholder='$0.00'
                                                                        value={
                                                                            field.value
                                                                                ? new Intl.NumberFormat('en-US', {
                                                                                    style: 'currency',
                                                                                    currency: 'USD',
                                                                                    minimumFractionDigits: 0,
                                                                                }).format(
                                                                                    parseFloat(
                                                                                        field.value.replace(/[^\d.]/g, '') || 0
                                                                                    )
                                                                                )
                                                                                : ''
                                                                        }
                                                                        onChange={(e) => {
                                                                            let rawValue = e.target.value.replace(/[^\d.]/g, '');
                                                                            form.setFieldValue('price', rawValue);
                                                                        }}
                                                                    />
                                                                )}
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div className='col-6'>
                                                        <div className='form-group mt-1'>
                                                            <div className='custom-checkbox showprice-checkbox'>
                                                                <Field
                                                                    type='checkbox'
                                                                    name='showPrice'
                                                                    id={`showprice-${special.id}`}
                                                                    onChange={(e) =>
                                                                        setFieldValue('showPrice', e.target.checked)
                                                                    }
                                                                />
                                                                <label
                                                                    htmlFor={`showprice-${special.id}`}
                                                                    className='w-100'
                                                                >
                                                                    Show Price
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Save Button */}
                                                <div className='text-end'>
                                                    <button
                                                        type='submit'
                                                        className='orange-btn w-180 text-uppercase add-new-special-btn'
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSpecials;
